import moment from "moment";

export function getDefaultGridView(storedValue) {
  return typeof storedValue === "boolean" ? storedValue : true;
}

export function createDefaultSearchState(gridView = true) {
  return {
    searchText: "",
    boardSearchText: "",
    boardSearch: [],
    epicSearch: [],
    dateRange: null,
    myTaskUser: [],
    taskTab: true,
    totalWorkHours: 0,
    gridView,
  };
}

export function normalizeSearchText(value) {
  return `${value ?? ""}`.toLowerCase();
}

export function addUniqueItem(items = [], value) {
  return items.includes(value) ? items : [...items, value];
}

export function removeItem(items = [], value) {
  return items.filter((item) => item !== value);
}

export function toggleEpicValue(items = [], value) {
  return items.includes(value)
    ? items.filter((item) => item !== value)
    : [...items, value];
}

export function normalizeEpicSearchPayload(value) {
  return Array.isArray(value) ? value : [value];
}

export function createDefaultDateRange() {
  return {
    startDate: moment().subtract(30, "days").toISOString(),
    endDate: moment().toISOString(),
  };
}
